import React, { useEffect, useState } from "react";
import UserList from "./components/UserList/UserList";
import CacheDate from "./components/CacheDate/CacheDate";
import Bowls from "./components/Bowls/Bowls.jsx";
import ConferenceWins from "./components/ConferenceWins/ConferenceWins.jsx";

function App() {
    const [bowls, setBowls] = useState([]);

    useEffect(() => {
        const fetchBowls = async () => {
            try {
                const response = await fetch("/api/bowls");
                const data = await response.json();
                console.log("Fetched bowl games:", data);
                setBowls(data);
            } catch (error) {
                console.error("Error fetching bowl games:", error);
            }
        };

        fetchBowls();
    }, []);

    return (
        <>
            <header className="site-header">
                <h1>2025 College Football Postseason Bowl Games & CFP</h1>
                <p>Including team logos and regular-season records</p>
                <CacheDate cacheDate={bowls.cacheDate} />
            </header>
            <main>
                <article className="users-and-conference-wins">
                    <UserList users={bowls.users} />
                    <ConferenceWins conferenceWins={bowls.conferenceWins} userCount={bowls.users ? bowls.users.length : 0} />
                </article>
                <Bowls bowls={bowls.games} conference={bowls.conferenceWins} teamPoints={bowls.TeamWithMostPoints} />
            </main>
        </>
    );
}

export default App;
